import { Toolbar as ToolbarPrimitive } from "@base-ui/react/toolbar";

import { cn } from "@/lib/utils";

function Toolbar({ className, ...props }) {
  return (
    <ToolbarPrimitive.Root
      data-slot="toolbar"
      className={cn(
        "tw:flex tw:flex-wrap tw:items-center tw:gap-0.5 tw:border-b tw:border-[var(--color-border)] tw:px-2 tw:py-1.5",
        className
      )}
      {...props}
    />
  );
}

// The visual styling lives on the element supplied through `render` (typically a
// Button), so this wrapper only carries the composite item and its slot marker.
function ToolbarButton(props) {
  return <ToolbarPrimitive.Button data-slot="toolbar-button" {...props} />;
}

function ToolbarSeparator({ className, ...props }) {
  return (
    <ToolbarPrimitive.Separator
      data-slot="toolbar-separator"
      className={cn(
        "tw:mx-1.5 tw:h-5 tw:w-px tw:bg-[var(--color-border)]",
        className
      )}
      {...props}
    />
  );
}

export { Toolbar, ToolbarButton, ToolbarSeparator };
